/* 표시용 날짜·시간 포맷 — 저장은 UTC ISO(변경 금지), 표시는 항상 한국시(KST, Asia/Seoul).
   어느 PC에서 열든(브라우저 TZ 무관) 동일하게 KST 로 보이도록 timeZone 을 고정한다.
   기존 표기 형식(YYYY-MM-DD / YYYY-MM-DD HH:mm)은 유지하고 값만 KST 로 교정. */
const KST = 'Asia/Seoul';

function partsKST(iso, withTime) {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const opts = { timeZone: KST, year: 'numeric', month: '2-digit', day: '2-digit' };
  if (withTime) Object.assign(opts, { hour: '2-digit', minute: '2-digit', hour12: false });
  // en-CA = YYYY-MM-DD 자릿수 보장. type 별로 뽑아 직접 조립(로케일 표기 흔들림 차단).
  const parts = new Intl.DateTimeFormat('en-CA', opts).formatToParts(d);
  const g = (t) => { const p = parts.find((x) => x.type === t); return p ? p.value : ''; };
  const date = `${g('year')}-${g('month')}-${g('day')}`;
  if (!withTime) return date;
  let hh = g('hour');
  if (hh === '24') hh = '00';   // hour12:false 자정 24시 → 00 보정(런타임별 quirk)
  return `${date} ${hh}:${g('minute')}`;
}

/* YYYY-MM-DD (KST). 빈/잘못된 값은 '—'. */
export const fmtDate = (iso) => partsKST(iso, false) || '—';

/* YYYY-MM-DD HH:mm (KST, 24시간). 빈/잘못된 값은 '—'. */
export const fmtDateTime = (iso) => partsKST(iso, true) || '—';
